// extracted by mini-css-extract-plugin
module.exports = {"contentForm":"manualoperadors_contentForm__C_Snz","botoEnvia":"manualoperadors_botoEnvia__w48nO","disabled":"manualoperadors_disabled__Ny7IN"};